export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend every Sunday night writing out barre combinations. Now I open the library, pick the class, and walk in completely prepared. My students feel the difference—and so do I.',
    author: 'S.M.',
    role: 'Ballet Teacher',
    location: 'London, UK',
  },
  {
    quote:
      'The pre-ballet activities alone were worth the entire price. I teach 3-6 year olds three times a week and was running out of ideas every month. Now I have 50 activities ready to go.',
    author: 'C.V.',
    role: 'Ballet Instructor',
    location: 'Toronto, Canada',
  },
  {
    quote:
      'The corrections and cueing library changed how I communicate with my students completely. My feedback is clearer, and my students understand what I’m asking them to do.',
    author: 'J.R.',
    role: 'Ballet Teacher',
    location: 'Sydney, Australia',
  },
]
